<div>
  <h2 mat-dialog-title>Logging out</h2>
  <mat-divider class="yellow-divider"></mat-divider>
  <mat-dialog-content>
    <div class="text-center">Logging you out in 3</div>
  </mat-dialog-content>
</div>
